import React from "react";
import "./style.scss";
import QRCode from "react-qr-code";
import useDesktopSize from "../../utils/hooks/useDesktopSize";

interface IProps {
  trhId: string;
  name: string;
}

const QrCodeModal: React.FC<IProps> = ({ name, trhId }: IProps) => {
  const isDesktop = useDesktopSize();
  return (
    <React.Fragment>
      <div className="qr-code-modal">
      {isDesktop ? ( <QRCode value={trhId} size={250} />) : ( <QRCode value={trhId} size={120} />)}
          <b className="qr-name">{name}</b>
          <span className="qr-code-text">{trhId}</span>
      </div>
    </React.Fragment>
  );
};

export default QrCodeModal;
